import * as React from 'react'
import { Formik } from 'formik'
import { Footer } from './Footer'
import { Content } from './Content'
import { WizardScreen } from '../WizardScreen'
import { useData, useHandlers, useOnSubmit } from './hooks'

export function Filters() {
  const onSubmit = useOnSubmit()

  const { initialValues, isRescheduling } = useData()

  const { validate } = useHandlers({ isRescheduling })

  return (
    <Formik
      enableReinitialize
      onSubmit={onSubmit}
      validate={validate}
      initialValues={initialValues}
    >
      <WizardScreen
        screen="filters"
        isRescheduling={isRescheduling}
        footer={<Footer />}
        padding={0}
      >
        <Content isRescheduling={isRescheduling} />
      </WizardScreen>
    </Formik>
  )
}
